// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__vk6dY","padding":"panel_padding__puSfW","numberContainer":"panel_numberContainer__nykhY","number":"panel_number__gAJXV","content":"panel_content__Vqd3e"};